/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".guest-stats[_ngcontent-%COMP%]{justify-content:space-between;align-items:center;display:flex;flex-direction:column}"];
export { styles as styles };
